@if (universitySections$ | async; as universitySections) {
	@if (!isObjectEmpty(universityInformation)) {
		<uc-university-section
			[externalUrl]="externalUrl()"
			[universitySection]="universityInformation"
			[uniId]="uniId()"
			[product]="product()"
			heading="{{ uniName() }} Key Information"
			[uniName]="uniName()"
			[ugSearchOrderPosition]="ugSearchOrderPosition()"
			data-cy="key-information-section"
		/>
	}
	@if (!isObjectEmpty(campusLife)) {
		<uc-university-section
			[externalUrl]="universitySections.external_campus_url"
			[universitySection]="campusLife"
			[uniId]="uniId()"
			[product]="product()"
			heading="Campus Life"
			[uniName]="uniName()"
			[ugSearchOrderPosition]="ugSearchOrderPosition()"
			data-cy="campus-life-section"
		/>
	}
	@if (!isObjectEmpty(tuitionFees)) {
		<uc-university-section
			[externalUrl]="universitySections.external_tuition_fees_url"
			[universitySection]="tuitionFees"
			[uniId]="uniId()"
			[product]="product()"
			heading="Tuition Fees, Scholarships and Bursaries"
			[uniName]="uniName()"
			[ugSearchOrderPosition]="ugSearchOrderPosition()"
			data-cy="tuition-fees-section"
		/>
	}
}
